import { LegalPage } from '@/components/LegalPage';
import { LandingPage } from '@/pages/landing';
import { TimelineDetailPage } from '@/pages/timeline';
import { TimelineListPage } from '@/pages/timeline-list';
import { trackPageView } from '@/shared/analytics';
import { createBrowserRouter, type RouteObject } from 'react-router-dom';

const pageNameMap: Record<string, string> = {
  '/': 'landing',
  '/timelines': 'timeline_list',
  '/terms': 'terms',
  '/privacy': 'privacy',
};

const resolvePageName = (pathname: string): string => {
  if (pageNameMap[pathname]) return pageNameMap[pathname];
  if (pathname.startsWith('/timeline/')) return 'timeline_detail';
  return pathname;
};

export const appRoutes: RouteObject[] = [
  {
    path: '/',
    element: <LandingPage />,
  },
  {
    path: '/timelines',
    element: <TimelineListPage />,
  },
  {
    path: '/timeline/:id',
    element: <TimelineDetailPage />,
  },
  {
    path: '/terms',
    element: <LegalPage kind="terms" />,
  },
  {
    path: '/privacy',
    element: <LegalPage kind="privacy" />,
  },
];

export const router = createBrowserRouter(appRoutes);

router.subscribe((state) => {
  const pageName = resolvePageName(state.location.pathname);
  trackPageView(pageName);
});
